import { PILLAR_HEIGHT, VIRTUAL_W } from '../../../sim/constants.js'
import type { Pillar } from '../../../sim/types.js'
import type { Projected } from '../camera.js'
import { INK_RGB } from './constants.js'

/** Blueprint pillar (15 §2.1): shaft split in two flat tones at the azimuth of the nearer floodlight
 *  column (the lights sit at x = ±4, so a pillar on screen-left is lit from screen-left), cap, AO ring,
 *  ink outline and a 1 px seam on the split. `alpha` = 1 − fog. */
export function drawPillar(ctx: CanvasRenderingContext2D, pl: Pillar, base: Projected, top: Projected, gridOnly: boolean, alpha = 1): void {
  if (!base.visible || alpha <= 0.01) return
  const rx = pl.r * base.scale
  ctx.save(); ctx.globalAlpha = alpha
  const litLeft = base.sx < VIRTUAL_W / 2
  const lit = gridOnly ? '#15191e' : '#2d353d', unlit = gridOnly ? '#15191e' : '#1d232a'
  ctx.fillStyle = litLeft ? lit : unlit
  ctx.fillRect(base.sx - rx, top.sy, rx, base.sy - top.sy)
  ctx.fillStyle = litLeft ? unlit : lit
  ctx.fillRect(base.sx, top.sy, rx, base.sy - top.sy)
  if (!gridOnly) { ctx.strokeStyle = `rgba(${INK_RGB},0.3)`; ctx.lineWidth = 1; ctx.beginPath(); ctx.moveTo(base.sx, top.sy); ctx.lineTo(base.sx, base.sy); ctx.stroke() }
  ctx.fillStyle = gridOnly ? '#1b2026' : '#3a434c'
  ctx.beginPath(); ctx.ellipse(base.sx, top.sy, rx, rx * 0.35, 0, 0, Math.PI * 2); ctx.fill()
  ctx.fillStyle = 'rgba(0,0,0,0.35)'
  ctx.beginPath(); ctx.ellipse(base.sx, base.sy, rx * 1.25, rx * 0.45, 0, 0, Math.PI * 2); ctx.fill()
  ctx.strokeStyle = `rgba(${INK_RGB},0.45)`; ctx.lineWidth = 1
  ctx.beginPath(); ctx.ellipse(base.sx, base.sy, rx, rx * 0.35, 0, 0, Math.PI); ctx.stroke()
  ctx.strokeRect(base.sx - rx, top.sy, rx * 2, base.sy - top.sy)
  ctx.restore()
}
export const pillarHeight = (pl: Pillar): number => pl.h || PILLAR_HEIGHT
